// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"440":"datadogProfiler","581":"datadogRecorder"}[chunkId] || chunkId) + "." + {"76":"2fac4f539c8a0e78","440":"df9b4c3061314456","581":"b8ea8bc39ffb71a6","688":"a0f63c76de98544e"}[chunkId] + ".js";
};